import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const PromotionalBanner = () => {
  const navigate = useNavigate();

  const highlights = [
    {
      id: 1,
      title: 'Program & Penawaran',
      description:
        'Beragam program pembelian motor Honda yang dirancang untuk memudahkan Anda memiliki motor impian.',
      image:
        'https://images.unsplash.com/photo-1556076007-79fe58a8d020',
      icon: 'Tag',
    },
    {
      id: 2,
      title: 'Layanan & Kemudahan',
      description:
        'Mulai dari simulasi kredit, konsultasi pembelian, hingga layanan purna jual resmi Honda.',
      image:
        'https://img.rocket.new/generatedImages/rocket_gen_img_1ad7141da-1767618119514.png',
      icon: 'Calendar',
    },
    {
      id: 3,
      title: 'Keunggulan Honda Berdikari',
      description:
        'Dealer & AHASS resmi Honda dengan pelayanan profesional dan proses yang transparan.',
      image:
        'https://img.rocket.new/generatedImages/rocket_gen_img_1ad7141da-1767618119514.png',
      icon: 'ShieldCheck',
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">

        {/* TAG / EYEBROW */}
        <div className="text-center mb-4" data-aos="fade-up">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-primary/10 text-primary">
            <Icon name="Tag" size={16} />
            <span className="text-sm font-heading font-semibold">
              Penawaran Honda Berdikari
            </span>
          </div>
        </div>

        {/* HEADER */}
        <div className="text-center mb-10 md:mb-14" data-aos="fade-up" data-aos-delay="100">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            Temukan Penawaran Terbaik di Honda Berdikari
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Jelajahi berbagai program, layanan, dan keuntungan pembelian motor Honda
            yang dirancang untuk kenyamanan Anda.
          </p>
        </div>

        {/* CONTENT CARDS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-aos="fade-up"data-aos-delay="200">
          {highlights.map((item) => (
            <div
              key={item.id}
              className="bg-card rounded-2xl overflow-hidden border border-border
                         hover:shadow-card-hover transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <Image
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="p-6 space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <Icon
                      name={item.icon}
                      size={20}
                      color="var(--color-primary)"
                    />
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground">
                    {item.title}
                  </h3>
                </div>

                <p className="text-sm text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center" data-aos="fade-up"data-aos-delay="300">
          <Button
            variant="default"
            size="lg"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/promo')}
            className="shadow-honda-subtle"
          >
            Lihat Promo & Program
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;
